import React from "react";
import TopNav from "@clockwise/web-commons/src/ui/TopNav";
import { logger } from "@src/util/logger.util";
import { getCurrentOrg } from "@src/util/org.util";
import { useLogout } from "./hooks/useLogout";
import { useQuery } from "@apollo/client";
import { TOP_NAV_QUERY } from "@clockwise/web-commons/src/ui/TopNav.graphql";
import { TopNav as TopNavResponse } from "@clockwise/web-commons/src/ui/__generated__/TopNav";

type Props = {
  pageTitle: string;
  feedbackUrl?: string;
  showCalendarButton?: boolean;
};

export function TopNavigation({ pageTitle, feedbackUrl, showCalendarButton = false }: Props) {
  const { data } = useQuery<TopNavResponse>(TOP_NAV_QUERY);
  const [logoutUser] = useLogout({
    onError: (error) => logger.error("An error occurred on logout", error),
  });
  const org = getCurrentOrg(data?.viewer);
  const user = org?.userPerson?.__typename === "Person" ? org.userPerson.profile : null;

  return (
    <TopNav
      user={user}
      organization={org?.name || ""}
      pageTitle={pageTitle}
      onLogout={logoutUser}
      feedbackUrl={feedbackUrl}
      showCalendarButton={showCalendarButton}
    />
  );
}
